import { render, staticRenderFns } from "./back-updatestockstatus.vue?vue&type=template&id=61adad08"
import script from "./back-updatestockstatus.vue?vue&type=script&lang=ts"
export * from "./back-updatestockstatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports